import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@coolblue-development/freddy';
// This is a temporary fix to be able to show the reviews element before we have the matching component
export function StyledReviewsWrapper({ id, children, ...rest }) {
    return (_jsx(Box, { id: id, ...rest, sx: {
            'div > div:nth-of-type(2) > div': {
                gridColumn: 'span 12 !important',
            },
            a: {
                display: 'none !important',
            },
        }, children: children }));
}
//# sourceMappingURL=MiniProductPage.styled.js.map